import React, { useEffect, useState } from "react";
import Style from "./BaseLayout.module.scss";
import Navbar from "./Navbar";
import Home from "./home/Home";
import About from "./about/About";
import Portfolio from "./portfolio/Portfolio";
import { Route, Routes } from "react-router-dom";
import { Email } from "@mui/icons-material";
import { Box, Grid, Container, Typography, IconButton } from "@mui/material";

export default function BaseLayout() {
  let [darkMode, setDarkMode] = useState(false);

  function handleToggleDarkMode() {
    let oppositeOfCurrentDarkMode = !darkMode;
    console.log(oppositeOfCurrentDarkMode);
    localStorage.setItem("darkMode", `${oppositeOfCurrentDarkMode}`);
    setDarkMode(oppositeOfCurrentDarkMode);
  }

  const copyToClipboard = () => {
    const email = "koturic96@gmail.com";
    navigator.clipboard.writeText(email);
    alert("E-mail copied to clipboard!");
  };

  useEffect(() => {
    let detectedDarkMode = eval(localStorage.getItem("darkMode"));

    if (detectedDarkMode) {
      setDarkMode(detectedDarkMode);
    } else {
      localStorage.setItem("darkMode", "false");
    }
  }, []);

  return (
    <Box className={darkMode ? Style.dark : Style.light}>
      <Grid
        container
        display={"flex"}
        flexDirection={"column"}
        minHeight={"100vh"}
        justifyContent={"space-between"}
      >
        <Grid item>
          <Navbar darkMode={darkMode} handleClick={handleToggleDarkMode} />
        </Grid>
        <Grid item flexGrow={1}>
          <Routes>
            <Route exact path={"/"} element={<Home />} />
            <Route exact path={"/about"} element={<About />} />
            <Route exact path={"/portfolio"} element={<Portfolio />} />
          </Routes>
        </Grid>
        <Grid item>
          <Box
            component="footer"
            py={2}
            sx={{
              // borderTop: "1px solid #ccc", // Dodali smo liniju iznad teksta
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              opacity: 0.7,
            }}
          >
            <Typography variant="body2">&copy; Ranko Koturić</Typography>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              mt={1} // Dodali smo razmak između ikonice i teksta
            >
              <IconButton onClick={copyToClipboard}>
                <Email
                  sx={{
                    color: darkMode ? "white" : "black",
                  }}
                />{" "}
              </IconButton>
              <Typography
                variant="body2"
                onClick={copyToClipboard}
                sx={{ cursor: "pointer" }}
              >
                koturic96@gmail.com
              </Typography>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
